import { useContext, useState, useEffect } from 'react';
import { Container, Navbar, Image } from 'react-bootstrap';
import { useSidebar } from '../App';
import { AuthContext } from '../context/AuthContext';
import '../styles/Header.css';
import AdminSidebar from './adminSidebar';
import { FONTS_CONFIG, loadGoogleFonts, getFontConfig } from '../config/fonts';

export default function Header() {
  const { isLoggedIn, userData } = useContext(AuthContext);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { sidebarCollapsed, toggleSidebarCollapse } = useSidebar();
  const [companyLogo, setCompanyLogo] = useState(null);
  const [companyName, setCompanyName] = useState('');
  const [companyFontKey, setCompanyFontKey] = useState(null);
  const [companyFontSize, setCompanyFontSize] = useState('24');

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
  const company_code = userData?.company_code;

  // Fetch company logo and name
  useEffect(() => {
    const fetchCompanyData = async () => {
      if (!company_code) return;
      try {
        const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';
        const response = await fetch(`${BASE_URL}/api/admin/companies-by-code/${company_code}`);
        const data = await response.json();
        if (data.success && data.company) {
          if (data.company.company_logo) {
            setCompanyLogo(`${BASE_URL}/uploads/company_logos/${data.company.company_logo}`);
          }
          if (data.company.company_name) {
            setCompanyName(data.company.company_name);
          }
          if (data.company.company_font_key) {
            setCompanyFontKey(data.company.company_font_key);
          }
          if (data.company.company_font_size) {
            setCompanyFontSize(data.company.company_font_size);
          }
        }
      } catch (err) {
        setCompanyLogo(null);
        setCompanyName('');
        setCompanyFontKey(null);
      }
    };
    fetchCompanyData();
  }, [company_code]);

  // Load and apply company font when it changes
  useEffect(() => {
    if (!companyFontKey) {
      // Use default fallback
      const defaultConfig = FONTS_CONFIG.montserrat;
      document.documentElement.style.setProperty(
        '--company-font',
        defaultConfig.css
      );
      if (defaultConfig.googleFont) {
        loadGoogleFonts(['montserrat']);
      }
      return;
    }

    // Get font configuration
    const fontConfig = getFontConfig(companyFontKey);

    // Set CSS variable on root element
    document.documentElement.style.setProperty(
      '--company-font',
      fontConfig.css
    );

    // Load Google Font if applicable
    if (fontConfig.googleFont) {
      loadGoogleFonts([companyFontKey]);
    }
  }, [companyFontKey]);

  return (
    <>
      <Navbar className="header" expand={false}>
        <Container fluid className="d-flex justify-content-between align-items-center position-relative">
          <div className="d-flex align-items-center">
            <Navbar.Brand className="mb-0 text-muted d-flex align-items-center gap-2">
              {isLoggedIn && (
                <AdminSidebar
                  sidebarOpen={sidebarOpen}
                  toggleSidebar={toggleSidebar}
                  sidebarCollapsed={sidebarCollapsed}
                  toggleSidebarCollapse={toggleSidebarCollapse}
                />
              )}
            </Navbar.Brand>
          </div>

          {/* Centered company name - only shown when logged in */}
          <div className="header-company-name text-center">
            {isLoggedIn && companyName && (
              <div className="company-name" title={companyName} style={{ fontFamily: 'var(--company-font)', fontSize: `${companyFontSize}px` }}>
                {companyName}
              </div>
            )}
          </div>

          {/* Company Logo Avatar on right, fallback to default avatar if not available */}
          <div className="d-flex align-items-center">
            {/* {isLoggedIn && (
              <Image
                src={companyLogo || 'https://cdn-icons-png.flaticon.com/512/149/149071.png'}
                alt="Company Logo"
                roundedCircle
                width={50}
                height={50}
                className="company-avatar ms-2"
                style={{ objectFit: 'cover', border: '1px solid #ccc', background: '#fff' }}
              />
            )} */}
          </div>
        </Container>
      </Navbar>
    </>
  );
}